import { render, staticRenderFns } from "./AddContactToGroupDialog.vue?vue&type=template&id=5f0b9f9c&scoped=true"
import script from "./AddContactToGroupDialog.vue?vue&type=script&lang=ts"
export * from "./AddContactToGroupDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b9f9c",
  null
  
)

export default component.exports